import apiQueries from "@/store/modules/admin/apiQueries";
import blockchain from "@/store/modules/admin/blockchain";
import buildings from "@/store/modules/admin/buildings";
import categories from "@/store/modules/admin/categories";
import cgu from "@/store/modules/admin/cgu";
import companies from "@/store/modules/admin/companies";
import keys from "@/store/modules/admin/keys";
import keyTransfers from "@/store/modules/admin/keyTranfers";
import plans from "@/store/modules/admin/plans";
import subscriptions from "@/store/modules/admin/subscriptions";
import sql from "@/store/modules/admin/sql";
import tags from "@/store/modules/admin/tags";
import users from "@/store/modules/admin/users";
import administration from "@/store/modules/admin/administration";

const state = {};

const getters = {};

const mutations = {};

const actions = {};

const modules = {
  apiQueries,
  blockchain,
  buildings,
  categories,
  cgu,
  companies,
  keys,
  keyTransfers,
  plans,
  subscriptions,
  sql,
  tags,
  users,
  administration,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
};
